import { getCookie, removeCookie, setCookie } from "../cookies/cookies";
import { getUTCDate } from "../getUTCDate/getUTCDate";
import {
  deletePassVerifiedData,
  PASS_VERIFIED_DATE_OF_BIRTH_COOKIE,
  PASS_VERIFIED_PHONE_COOKIE,
} from "../passVerificationData";

export const EXPIRING_AGE_CONFIRMED_COOKIE = "isExpiringAgeVerified";
export const AGE_VERIFICATION_UUID = "ageVerificationUuid";

export const getIsAgeVerificationNotExpired = () => {
  const isDiiaAgeConfirmedCookie = getCookie(EXPIRING_AGE_CONFIRMED_COOKIE);

  return isDiiaAgeConfirmedCookie === "true";
};

export const setExpiringAgeVerification = (ttlInSeconds: number = 24 * 60 * 60) => {
  const ttlInMs = ttlInSeconds * 1000;
  const ttlOfAgeVerification = getUTCDate(ttlInMs);

  setCookie(EXPIRING_AGE_CONFIRMED_COOKIE, true, "/", ttlOfAgeVerification);
};

export const setAgeVerificationUuid = (uuid: string, ttlInSeconds: number = 24 * 60 * 60, path?: string) => {
  const ttlInMs = ttlInSeconds * 1000;
  const ttlOfAgeVerification = ttlInMs ? getUTCDate(ttlInMs) : undefined;
  setCookie(AGE_VERIFICATION_UUID, uuid, path ?? "/", ttlOfAgeVerification);
};

export const getAgeVerificationUuid = () => {
  const uuid = getCookie(AGE_VERIFICATION_UUID);
  const isUuidValid = uuid && typeof uuid === "string";
  return isUuidValid ? uuid : null;
};

export const removeAgeVerificationUuid = () => {
  removeCookie(AGE_VERIFICATION_UUID, "/");
};

export const removeExpiringAvVerified = () => {
  removeCookie(EXPIRING_AGE_CONFIRMED_COOKIE);
};

export const clearAvData = () => {
  removeAgeVerificationUuid();
  removeExpiringAvVerified();
  deletePassVerifiedData(PASS_VERIFIED_PHONE_COOKIE);
  deletePassVerifiedData(PASS_VERIFIED_DATE_OF_BIRTH_COOKIE);
};
